// extracted by mini-css-extract-plugin
module.exports = {"spinnerWrapper":"loader_spinnerWrapper__2xAe_","spinner":"loader_spinner__1RtIs","scale":"loader_scale__2Mh0s","label":"loader_label__2V_5n"};